import { render, staticRenderFns } from "./WidgetFooter.vue?vue&type=template&id=6c622fa6&"
import script from "./WidgetFooter.vue?vue&type=script&lang=ts&"
export * from "./WidgetFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports